import React, { useLayoutEffect, useRef, useState } from 'react';
import './ResilientImage.css';

/**
 * Keeps an image's footprint visible while it is loading or unavailable.
 * useLayoutEffect checks browser cache before paint, so cached images do not
 * briefly show the loading treatment.
 */
const ResilientImage = ({ onLoad, onError, className = '', ...props }) => {
    const imageRef = useRef(null);
    const [status, setStatus] = useState('loading');

    useLayoutEffect(() => {
        const image = imageRef.current;
        setStatus(image?.complete && image.naturalWidth > 0 ? 'ready' : 'loading');
    }, [props.src]);

    const handleLoad = (event) => {
        setStatus('ready');
        onLoad?.(event);
    };

    const handleError = (event) => {
        setStatus('error');
        onError?.(event);
    };

    return (
        <span className={`resilient-image ${status !== 'ready' ? 'is-pending' : ''}`}>
            <img
                {...props}
                ref={imageRef}
                className={className}
                onLoad={handleLoad}
                onError={handleError}
                aria-hidden={status === 'error' ? true : undefined}
            />
            {status !== 'ready' && (
                <span className="resilient-image__fallback" aria-hidden="true">
                    <span className="resilient-image__fiber resilient-image__fiber--one" />
                    <span className="resilient-image__fiber resilient-image__fiber--two" />
                    <span className="resilient-image__fiber resilient-image__fiber--three" />
                </span>
            )}
        </span>
    );
};

export default ResilientImage;
